import { Component, OnInit } from '@angular/core';
import {PermissionService} from '../../api/permission.service';
import {take} from 'rxjs/operators';

@Component({
    selector: 'app-resources',
    templateUrl: './resources.component.html',
    styleUrls: ['./resources.component.css'],
    standalone: false
})
export class ResourcesComponent implements OnInit {
  public isActive: boolean;

  constructor(public permissionService: PermissionService) { }

  ngOnInit(): void {
    this.permissionService.getPermissions()
      .pipe(take(1))
      .subscribe(permission => {
        this.isActive = permission.open;
      });
  }


  goToRepository() {
    window.location.href = 'https://github.com/debbeca/java-angular-boilerplate';
  }

}
